// FearGreedWidget/FearGreedHistoryChart.jsx
// Pure painter — mini bar chart of the 31-day history. No state, no fetch logic.
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import FearGreedSegmentCalculator from './FearGreedSegmentCalculator';
import { emsToDateDisplay } from '../../../services/utils/DateFormat';
import { tooltipSxElevated } from '../../../components/shared/jernyTooltipStyling';

const CHART_HEIGHT = 44;

/**
 * @param {{history:{value:number,ems:number}[]}} props - oldest first
 * @returns {JSX.Element}
 */
function FearGreedHistoryChart({ history }) {
    const oldest = history[0];

    return (
        <div className="fgw-history">
            <div className="fgw-history-bars">
                {history.map((item, i) => {
                    const color = FearGreedSegmentCalculator.getSegment(item.value).color;
                    const height = Math.max(3, (item.value / 100) * CHART_HEIGHT);
                    return (
                        <Tooltip key={item.rk ?? i} title={`${emsToDateDisplay(item.ems)} — ${item.value}`} componentsProps={tooltipSxElevated}>
                            <div className="fgw-history-bar" style={{ height, background: color }} />
                        </Tooltip>
                    );
                })}
            </div>
            <div className="fgw-history-labels">
                <span>{oldest ? emsToDateDisplay(oldest.ems) : ''}</span>
                <span>today</span>
            </div>
        </div>
    );
}

export default FearGreedHistoryChart;
